import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config/config.service';
import { SircleSlug, Slugger } from './slug-models';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class SlugApiService {
  private readonly keycloakService = inject(KeycloakService);
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject(ConfigService);


  private buildHeaders() {
    const HEADERS = {
      Authorization: `Bearer ${this.keycloakService.getKeycloakInstance().token}`
    };
    return HEADERS;
  }

  getSlugger(): Observable<Slugger> {
    const HEADERS = this.buildHeaders();
    return this.httpClient.get<Slugger>(`${this.config.apiUrl}/slug/slugger`, {
      headers: HEADERS,
      responseType: 'json'
    });
  }

  suggestSircleSlugName(data: SircleSlug): Observable<string> {
    const HEADERS = this.buildHeaders();
    return this.httpClient.post(`${this.config.apiUrl}/slug/sircle`, data, {
      headers: HEADERS,
      responseType: 'text'
    });
  }
}
